import { useQuery } from '@tanstack/react-query'

import type { MyBookingListItem } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { bookingKeys } from './keys.js'

export const useGetMyBookingsQuery = () =>
  useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<MyBookingListItem[]>('/me/bookings')
      return response.data
    },
    queryKey: bookingKeys.myBookings,
  })
